// extracted by mini-css-extract-plugin
export default {"column_search":"ColumnConfig_column_search__uCm+5","range_input":"ColumnConfig_range_input__VK3Hu"};